import { Link } from 'react-router-dom';
import { commodities } from '../../../mocks/commodities';
import type { CommodityDetail } from '../../../mocks/commodities';

interface Props {
  current: CommodityDetail;
}

export default function RelatedCommodities({ current }: Props) {
  const others = commodities.filter((c) => c.slug !== current.slug);

  return (
    <section className="bg-white py-20 px-6 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-12">
          <div>
            <p className="text-[#d4571a] text-xs font-bold tracking-widest uppercase mb-3">
              Explore More
            </p>
            <h2 className="text-[#071525] text-2xl md:text-3xl font-bold leading-tight">
              Other Commodity Categories
            </h2>
          </div>
          <Link
            to="/#products"
            className="text-[#d4571a] text-xs font-bold tracking-widest uppercase flex items-center gap-1 hover:gap-2 transition-all duration-200 whitespace-nowrap"
          >
            VIEW ALL <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {others.map((item) => (
            <Link
              key={item.slug}
              to={`/products/${item.slug}`}
              className="group border border-[#071525]/10 rounded-xl p-6 flex items-start gap-4 hover:border-[#d4571a]/40 hover:bg-[#fdf9f3] transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#071525]/5 group-hover:bg-[#d4571a]/15 transition-colors duration-300 flex-shrink-0">
                <i className={`${item.icon} text-[#071525]/50 group-hover:text-[#d4571a] text-xl transition-colors duration-300`} />
              </div>
              <div>
                <h3 className="text-[#071525] text-sm font-bold mb-1 group-hover:text-[#d4571a] transition-colors duration-200">
                  {item.label}
                </h3>
                <p className="text-[#071525]/45 text-xs leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
              <i className="ri-arrow-right-line text-[#071525]/20 group-hover:text-[#d4571a] text-base ml-auto flex-shrink-0 mt-0.5 transition-colors duration-200" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
